import { render, staticRenderFns } from "./bar_chart_horizontal.vue?vue&type=template&id=502003b4"
import script from "./bar_chart_horizontal.vue?vue&type=script&lang=js"
export * from "./bar_chart_horizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports